import { Button, Heading, Text } from "@instacover/ui"
import { createFileRoute, Link } from "@tanstack/react-router"
import { Trans, useTranslation } from "react-i18next"

import { BaseLayout } from "../../../../components/layouts/BaseLayout"
import permissionsAddressBar from "../../../../images/other/permissionsAddressBar.png"
import { LINKS } from "../../../../routing/links"

export const Route = createFileRoute("/$sessionId/_session/permissions-reset-guide/android")({
  component: PermissionsResetGuideAndroid,
})

function PermissionsResetGuideAndroid() {
  const { t } = useTranslation()
  const { sessionId } = Route.useParams()

  return (
    <BaseLayout hideCounter>
      <div className="h-10 w-10 shrink-0" />

      <div className="px-5">
        <Heading variant="h3" as="h3">
          {t("permissions.reset.guide.title")}
        </Heading>

        <div className="h-4 w-4 shrink-0" />

        <Text as="p">
          <Trans
            i18nKey="permissions.reset.guide.step.one"
            components={{
              primary: <strong className="text-ic-primary font-bold" />,
              bold: <strong className="font-bold" />,
            }}
          />
        </Text>

        <div className="h-4 w-4 shrink-0" />

        <div className="relative max-w-full">
          <img className="max-w-full object-contain" crossOrigin="anonymous" src={permissionsAddressBar} />
        </div>

        <div className="h-8 w-8 shrink-0" />

        <Text as="p">
          <Trans
            i18nKey="permissions.reset.guide.step.two"
            components={{
              primary: <strong className="text-ic-primary font-bold" />,
              bold: <strong className="font-bold" />,
            }}
          />
        </Text>

        <div className="h-4 w-4 shrink-0" />

        <Text as="p">
          <Trans
            i18nKey="permissions.reset.guide.step.three"
            components={{
              primary: <strong className="text-ic-primary font-bold" />,
              bold: <strong className="font-bold" />,
            }}
          />
        </Text>

        <div className="h-4 w-4 shrink-0" />

        <Text as="p">
          <Trans
            i18nKey="permissions.reset.guide.step.four"
            components={{
              primary: <strong className="text-ic-primary font-bold" />,
              bold: <strong className="font-bold" />,
            }}
          />
        </Text>

        <div className="h-8 w-8 shrink-0" />

        {/* Offset for fixed button */}
        <div className="h-24 w-24 shrink-0" />

        <div className="fixed right-10 bottom-10 left-10">
          <Link to={sessionId ? LINKS.guide(sessionId) : ""}>
            <Button>{t("permissions.reset.guide.back")}</Button>
          </Link>
        </div>
      </div>
    </BaseLayout>
  )
}
